/*!
 * EGT — /ig/swole  (the @theswoleginger BRIDGE — elevated).
 *
 * For the lifting audience arriving from @theswoleginger. Its ONE job is to
 * survive the context switch — "the guy from the gym wrote a book" — and put the
 * free-chapters offer invitingly in front of them. Redesigned from a text dump to
 * a CINEMATIC one-screen bridge: the gym photo does the trust work as an undimmed
 * full-bleed backdrop; a single frosted capture card floats over it, above the
 * fold on mobile. Contrast comes only from the frosted card (agents.md §4).
 *
 * THE CAPTURE is S.capture({source:"ig-swole"}) — a distinct attributed source
 * (egt.capture.js SOURCES + egt.free-sample.js PROMISED_SOURCES) so lifting-account
 * signups are attributed on the founder's dashboard AND still minted the free
 * sample. Minimal locked nav (brand + one book CTA); rem-only, gold scarce,
 * Playfair + Inter, mobile-first.
 */

var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.ig.swole",
  title: "The guy from the gym wrote a book",
  description: "From @theswoleginger — read the free opening of Exploit, a cinematic spiritual thriller by Justin K Kazmierczak.",
  supportServer: true
});
var S = require("../helpers/egt.sections.js");

function freeCapture() {
  return S.capture({
    source: "ig-swole",
    id: "egt-cap-ig-swole",
    variant: "panel",
    heading: "h1",
    eyebrow: "From your feed · @theswoleginger",
    title: [ "The guy from the gym ", { n: "span", c: "egt__gold", i: "wrote a book." } ],
    lead: [ "Same guy from your feed. ", { n: "em", i: "Exploit" }, " is my novel — a cinematic spiritual thriller about a man who loses everything and finds he was never falling alone. Read the opening free and see if it grips you." ],
    label: "Your email address",
    cta: "Send me the free chapters",
    consent: true,
    dialog: true,
    consentLabel: [ "Yes — email me the free opening of ", { n: "em", i: "Exploit" }, ", then new chapters, album drops and news from EGT. I can unsubscribe from any email." ],
    dialogLead: "",
    note: "You agree to the "
  });
}

exports.render = async function render() {
  var content = { n: "div", c: "egt-swole",
    i: [
      { n: "section", c: "egt-swole__hero", id: "swole-free",
        i: [
          /* undimmed full-bleed gym photo — the proof it's the same guy */
          /* content image (it IS the proof), so it carries a real alt and is not aria-hidden */
          { n: "div", c: "egt-swole__bg",
            i: { n: "img", c: "egt-swole__bg-img", src: "/imgs/founder/justin-gym.jpg",
              alt: "Justin K Kazmierczak, author of Exploit, in a sleeveless workout shirt outside the gym", loading: "eager", decoding: "async", fetchpriority: "high" } },
          /* a frosted caption chip pinned over the photo (the "framed caption") */
          { n: "figcaption", c: "egt-swole__chip egt-reveal",
            i: [ { n: "span", c: "egt-swole__chip-nm", i: "Justin" },
              { n: "span", c: "egt-swole__chip-sub", i: "@theswoleginger" } ] },
          { n: "div", c: "egt__shell egt-swole__inner",
            i: {
              n: "div", c: "egt-swole__col egt-reveal egt-reveal--up",
              i: [
                freeCapture(),
                { n: "p", c: "egt-swole__cap-alt",
                  i: [ "Want the full page first? ",
                    { n: "a", c: "egt-swole__inline-link", href: "/exploit/free", i: "Read about the book →" } ] },
                { n: "p", c: "egt-swole__proof",
                  i: "For readers of Frank Peretti and Ted Dekker · Book One of The Universe" }
              ]
            } }
        ] }
    ] };
  return S.page("/exploit", [ content,
    /* JSON-LD: WebPage + BreadcrumbList (SEO wave 2B-7) */
    S.pageSchema({ path: "/ig/swole", name: "The guy from the gym wrote a book", about: "/exploit#book", crumbs: [ { name: "Start here", path: "/ig" }, { name: "The guy from the gym wrote a book" } ] }) ], {
    navCta: { label: "Read the free chapters", href: "#swole-free" },
    minimalNav: true,
    hideAnnounce: true
  });
};
